"use client";
import Divider from "@mui/material/Divider";
import { Container } from "@mui/system";
import SongTiles from "~/components/audio/SongTiles";
import { Pagination, Song } from "~/types";


type Props = {
  songs: Pagination<Song>;
};

export default function HomePageLoggedIn({ songs }: Props) {
  if (!songs || songs.pagination.total === 0) {
    return null;
  }

  return (
    <>
      <Divider />
      <Container maxWidth="xl" disableGutters sx={{ overflowX: "hidden" }}>
        <SongTiles
          playlist={songs.data}
          size={140}
          variant="carousel"
          sx={{ px: 2, py: 2 }}
          actionsVariant="customer-order"
          showAddTile
        />
      </Container>
      <Divider />
    </>
  );
}
